const FullLayout = ({ children }) => {
  return <>{children}
  
  </>;
};

export default FullLayout;
